import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Navbar from "./components/Navbar";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Contact from "./components/Contact";
import "./App.css";

function App() {
  useEffect(() => {
    // Initialize AOS with mobile-friendly configuration
    const isMobile = window.innerWidth <= 768;
    AOS.init({
      duration: isMobile ? 600 : 800, // Faster animations on mobile
      easing: "ease-in-out-quad",
      once: isMobile, // Single animation on mobile to reduce jank
      mirror: !isMobile, // Disable mirror on mobile for performance
      anchorPlacement: "top-bottom",
      offset: isMobile ? 50 : 120, // Smaller offset for mobile
    });

    // Enhanced scroll reveal effect with IntersectionObserver
    const revealElements = document.querySelectorAll(".scroll-reveal");
    
    const observerOptions = {
      threshold: isMobile ? 0.05 : 0.1, // Lower threshold for mobile
      rootMargin: isMobile ? "0px 0px -30px 0px" : "0px 0px -50px 0px",
    };

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        } else if (!isMobile) {
          // Only remove active class on non-mobile for repeat animations
          entry.target.classList.remove("active");
        }
      });
    }, observerOptions);

    revealElements.forEach((el) => revealObserver.observe(el));

    // Smooth scroll for anchor links with touch support
    const handleSmoothScroll = (e) => {
      e.preventDefault();
      const targetId = e.target.getAttribute("href")?.startsWith("#")
        ? e.target.getAttribute("href")
        : e.target.closest("a[href^='#']")?.getAttribute("href");
      
      if (targetId && window.location.pathname === new URL(e.target.href).pathname) {
        const target = document.querySelector(targetId);
        if (target) {
          const navbarHeight = isMobile ? 60 : 80; // Smaller navbar offset on mobile
          window.scrollTo({
            top: target.offsetTop - navbarHeight,
            behavior: "smooth",
          });
        }
      }
    };

    // Add event listeners for both click and touch
    const anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach((anchor) => {
      anchor.addEventListener("click", handleSmoothScroll);
      anchor.addEventListener("touchstart", handleSmoothScroll, { passive: true });
    });

    // Ensure viewport meta tag for mobile responsiveness
    const metaViewport = document.querySelector('meta[name="viewport"]');
    if (!metaViewport) {
      const meta = document.createElement("meta");
      meta.name = "viewport";
      meta.content = "width=device-width, initial-scale=1, shrink-to-fit=no";
      document.head.appendChild(meta);
    }

    // Handle window resize for dynamic AOS refresh
    const handleResize = () => {
      AOS.refresh();
    };
    window.addEventListener("resize", handleResize);

    // Cleanup function
    return () => {
      revealObserver.disconnect();
      anchors.forEach((anchor) => {
        anchor.removeEventListener("click", handleSmoothScroll);
        anchor.removeEventListener("touchstart", handleSmoothScroll);
      });
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="App" style={{ backgroundColor: "black", minHeight: "100vh" }}>
      <Navbar />
      <main>
        <About />
        <Skills />
        <Projects />
        <Experience />
        <Contact />
      </main>
    </div>
  );
}

export default App;